import { render, staticRenderFns } from "./VoucherList.vue?vue&type=template&id=71c08de7&scoped=true&"
import script from "./VoucherList.vue?vue&type=script&lang=js&"
export * from "./VoucherList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c08de7",
  null
  
)

export default component.exports